import produce from 'immer';

import { AUTH_STATE_LOGIN, AUTH_STATE_LOGOUT, AUTH_STATE_UNKNOWN } from '../../../constants/state';
import { AUTH_FLOW_BEGIN, AUTH_FLOW_END, LOGOUT } from '../../constants/actionTypes';

const initState = AUTH_STATE_UNKNOWN;

export default produce((draft, action) => {
  switch (action.type) {
    case AUTH_FLOW_BEGIN: {
      return AUTH_STATE_UNKNOWN;
    }

    case AUTH_FLOW_END: {
      switch (action.payload) {
        case AUTH_STATE_LOGIN:
        case AUTH_STATE_LOGOUT: {
          return action.payload;
        }
      }
      break;
    }

    case LOGOUT: {
      return AUTH_STATE_LOGOUT;
    }
  }
}, initState);
